<template>
  <div class="survey-template" v-if="ready">
    <h4>Adaptation Plan</h4>
    <table v-for="(item, key, index) in adaptationPlan" :key="key" style="margin-bottom: 32px;">
      <thead>
        <tr>
          <th>
            {{ item.label }}  -  <span class="blue-text text-darken-3">{{dataValue[index].section.word_count}} Words</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
          <div 
            v-if="dataValue.length"
            v-html="dataValue[index].section.value"></div>
      
          </td>
        </tr>
      </tbody>
    </table>   
      
      
<!--     <div v-for="(item, key, index) in adaptationPlan" :key="key">
      <div class="survey-title">
        {{ item.label }}
      </div>
      <div
        class="content-row  proposed proposed grey lighten-3"
        v-if="dataValue.length"
        v-html="dataValue[index].section.value"
      ></div>
    </div> -->
  </div>
</template>
<script>
import adaptationPlan from "@/JsonSchemas/adaptationPlan";
import contentEditorComponent from "@/components/contentEditor.component";
export default {
  name: "AdaptationPlan",
  components: {
    contentEditorComponent,
  },
  props: {
    dataValue: {
      type: [Array],
    },
  },
  data: () => {
    return {
      adaptationPlan,
      ready: false,
    };
  },
  mounted() {
    this.dataValue && (this.ready = true);
  },
  methods: {
    $_format(val) {
      const charOne = val.charAt(0);

      return `${charOne.toUpperCase()}${val.substring(1)}`;
    },
  },
};
</script>
<style lang="scss" scoped>
  table {
    thead {
      background: rgba(0,0,0,0.08);
      padding: 12px;
    }
  }
  td, th {
    border: 1px solid lightgray !important;
    padding: 12px;
    p {
      margin: 6px 0px;
    }
  }
</style>
